import * as ACTIONS_TYPE from './actionsTypes';

export const updateError = (error, titulo, bloquearFlujo, labelAccion, accion, labelCancelar, cancelar) => {
    return {
        type: ACTIONS_TYPE.UPDATE_ERROR,
        payload: {
            error,
            titulo,
            bloquearFlujo,
            labelAccion,
            accion,
            labelCancelar,
            cancelar
        }
    }
}

export const updateEstadoCargando = (estadoCargando) => {
    return {
        type: ACTIONS_TYPE.UPDATE_ESTADO_CARGANDO,
        payload: {
            estadoCargando
        }
    }
}

export const updateTiempoSesion = (tiempoSesion) => {
    return {
        type: ACTIONS_TYPE.UPDATE_TIEMPO_SESION,
        payload: {
            tiempoSesion
        }
    }
}

export const guardarDatosUsuario = (usuario) => {
    return {
        type: ACTIONS_TYPE.SET_DATOS_USUARIO,
        payload: {
            usuario
        }
    }
}

export const guardarBeneficios = (beneficios) => {
    return {
        type: ACTIONS_TYPE.SET_BENEFICIOS,
        payload: {
            beneficios
        }
    }
}

export const guardarExclusiones = (exclusiones) => {
    return {
        type: ACTIONS_TYPE.SET_EXCLUSIONES,
        payload: {
            exclusiones
        }
    }
}

export const getUsuario = (IdUsuario) => {
    return {
        type: ACTIONS_TYPE.GET_USUARIO,
        payload: {
            IdUsuario
        }
    }
}

export const setLogin = (user) => {
    return {
        type: ACTIONS_TYPE.LOGIN,
        payload: {
            user
        }
    }
}

export const logout = () => {
    return {
        type: ACTIONS_TYPE.LOGOUT
    }
}

export const updateToken = (token) => {
    return {
        type: ACTIONS_TYPE.UPDATE_TOKEN,
        payload: {
            token
        }
    }
}

export const setListaProspectos = (listaProspectos) => {
    return {
        type: ACTIONS_TYPE.SET_LISTA_PROSPECTOS,
        payload: {
            listaProspectos
        }
    }
}

export const setDataProspecto = (prospecto) => {
    return {
        type: ACTIONS_TYPE.SET_DATA_PROSPECTO,
        payload: {
            prospecto
        }
    }
}

export const continuarProceso = (url) => {
    return {
        type: ACTIONS_TYPE.CONTINUAR_PROCESO,
        payload: {
            url
        }
    }
}

//funcion para limpiar pintado del submenu
export const limpiarProceso = () => {
    return {
        type: ACTIONS_TYPE.LIMPIAR_DATA_PROCESO
    }
}

export const actualizarProspecto = () => {
    return {
        type: ACTIONS_TYPE.UPDATE_DATA_PROSPECTO
    }
}

export const finalizarProspecto = () => {
    return {
        type: ACTIONS_TYPE.FINALIZAR_PROSPECTO
    }
}

export const eliminarOpcionMenu = (url) => {
    return {
        type: ACTIONS_TYPE.DELETE_OPCION_MENU,
        payload: {
            url
        }
    }
}

export const setSolicitudProspecto = (idSolicitudMultiple, solicitudes, productos, flagDeclaracion) => {
    return {
        type: ACTIONS_TYPE.SET_SOLICITUD_PROSPECTO,
        payload: {
            idSolicitudMultiple,
            solicitudes,
            productos,
            flagDeclaracion
        }
    }
}

export const setAseguradoProspecto = (asegurado) => {
    return {
        type: ACTIONS_TYPE.SET_ASEGURADO_PROSPECTO,
        payload: {
            asegurado
        }
    }
}

export const setAseguradoAdicionalProspecto = (aseguradoAdicional) => {
    return {
        type: ACTIONS_TYPE.SET_ASEGURADO_ADICIONAL_PROSPECTO,
        payload: {
            aseguradoAdicional
        }
    }
}

export const updateLpdpProspecto = (flag, flagAdicional, codigo) => {
    return {
        type: ACTIONS_TYPE.UPDATE_LPDP_PROSPECTO,
        payload: {
            flag,
            flagAdicional,
            codigo
        }
    }
}

export const updateAseguradoProspecto = (preguntas, subpreguntas) => {
    return {
        type: ACTIONS_TYPE.UPDATE_ASEGURADO_PROSPECTO,
        payload: {
            preguntas,
            subpreguntas
        }
    }
}

export const updateAseguradoAdicionalProspecto = (preguntasAdicional, subpreguntasAdicional) => {
    return {
        type: ACTIONS_TYPE.UPDATE_ASEGURADO_ADICIONAL_PROSPECTO,
        payload: {
            preguntasAdicional,
            subpreguntasAdicional
        }
    }
}

export const updateEstadoProspecto = () => {
    return {
        type: ACTIONS_TYPE.UPDATE_ESTADO_PROSPECTO
    }
}

export const updateEstadoFirma = () => {
    return {
        type: ACTIONS_TYPE.UPDATE_ESTADO_FIRMA
    }
}

/**
 * image es en base64
 * type puede ser 'posterior' o 'frontal'
 * identification puede ser 'asegurado' o 'contratante'
 */
export const setPhoto = (image, type, identification) => {
    return {
        type: ACTIONS_TYPE.UPDATE_INFORMATION_PHOTO,
        payload: {
            image,
            type,
            identification
        }
    }
}

export const setPhotoAdicional = (image, type, identification) => {
    return {
        type: ACTIONS_TYPE.UPDATE_INFORMATION_PHOTO_ADICIONAL,
        payload: {
            image,
            type,
            identification
        }
    }
}

// AssessmentId y Coberturas con respuestas de reflex a enviar en firma
export const reflexDataResponseFirma = (assessmentId, coberturas) => {
    return {
        type: ACTIONS_TYPE.REFLEX_DATA_RESPONSE_FIRMA,
        payload: {
            assessmentId,
            coberturas
        }
    }
}

export const setRequisitosIniciales = (requisitos) => {
    return {
        type: ACTIONS_TYPE.SET_REQUISITOS_INICIALES,
        payload: {
            requisitos
        }
    }
}

//NUEVO PROCESO
export const setCotizaciones = (cotizaciones) => {
    return {
        type: ACTIONS_TYPE.SET_COTIZACIONES,
        payload: {
            cotizaciones
        }
    }
}

export const setDatosInicialesCotizacion = (codigoCotizacion, esDistintoAsegurado, esAPFamiliar, requiereFirmaConyuge, requiereIngresoHijos, productos) => {
    return {
        type: ACTIONS_TYPE.SET_DATOS_INICIALES_COTIZACION,
        payload: {
            codigoCotizacion,
            esDistintoAsegurado,
            esAPFamiliar,
            requiereFirmaConyuge,
            requiereIngresoHijos,
            productos
        }
    }
}

export const setContratanteCotizacion = (contratante) => {
    return {
        type: ACTIONS_TYPE.SET_CONTRATANTE_COTIZACION,
        payload: {
            contratante
        }
    }
}

//TABLAS MAESTRAS
export const setTablasMaestras = (tablasMaestras) => {
    return {
        type: ACTIONS_TYPE.SET_TABLAS_MAESTRAS,
        payload: {
            tablasMaestras
        }
    }
}

export const setParametros = (parametros) => {
    return {
        type: ACTIONS_TYPE.SET_PARAMETROS,
        payload: {
            parametros
        }
    }
}

export const agregarTablaMaestra = (codigo, descripcion, registros) => {
    return {
        type: ACTIONS_TYPE.AGREGAR_TABLA_MAESTRA,
        payload: {
            codigo,
            descripcion,
            registros
        }
    }
}

export const updateCorreoContratante = (correo) => {
    return {
        type: ACTIONS_TYPE.UPDATE_CORREO_CONTRATANTE,
        payload: {
            correo
        }
    }
}

export const updateCorreoAsegurado = (correo) => {
    return {
        type: ACTIONS_TYPE.UPDATE_CORREO_ASEGURADO,
        payload: {
            correo
        }
    }
}

//BENEFICIARIOS
export const setBeneficiarios = (beneficiarios) => {
    return {
        type: ACTIONS_TYPE.SET_BENEFICIARIOS,
        payload: {
            beneficiarios
        }
    }
}

export const agregarRecurrente = (pagos) => {
    return {
        type: ACTIONS_TYPE.SET_PAGO_RECURRENTE,
        payload: {
            pagos
        }
    }
}

export const agregarCodAgencia = (codigo) => {
    return {
        type: ACTIONS_TYPE.SET_CODIGO_AGENCIA,
        payload: {
            codigo
        }
    }
}

export const updateDetalleReemplazoField = (campo, valor, indice) => {
    return {
        type: ACTIONS_TYPE.UPDATE_REEMPLAZO_FIELD,
        payload: {
            campo,
            valor,
            indice
        }
    }
}

export const cleanAseguradoField = (valor, noTiene) => {
    return {
        type: ACTIONS_TYPE.CLEAN_ASEGURADO_FIELD,
        payload: {
            valor,
            noTiene
        }
    }
}

export const deleteDetalleReemplazo = (idSolicitud) => {
    return {
        type: ACTIONS_TYPE.DELETE_DETALLE_REEMPLAZO,
        payload: {
            idSolicitud
        }
    }
}

export const updateRespuestaRapida = (valor) => {
    return {
        type: ACTIONS_TYPE.UPDATE_RESPUESTA_RAPIDA,
        payload: {
            valor
        }
    }
}

export const addContadorPago = (codMoneda) => {
    return {
        type: ACTIONS_TYPE.ADD_PAGO_CONTADOR,
        payload: {
            codMoneda

        }
    }
}

export const updateSolicitud = (solicitud) => {
    return {
        type: ACTIONS_TYPE.UPDATE_SOLICITUD,
        payload: {
            solicitud
        }
    }
}

export const updateDetalleReemplazoFieldAdicional = (campo, valor, indice) => {
    return {
        type: ACTIONS_TYPE.UPDATE_REEMPLAZO_FIELD_ADICIONAL,
        payload: {
            campo,
            valor,
            indice
        }
    }
}

export const cleanAseguradoFieldAdicional = (valor, noTiene) => {
    return {
        type: ACTIONS_TYPE.CLEAN_ASEGURADO_FIELD_ADICIONAL,
        payload: {
            valor,
            noTiene
        }
    }
}

export const deleteDetalleReemplazoAdicional = (idSolicitud) => {
    return {
        type: ACTIONS_TYPE.DELETE_DETALLE_REEMPLAZO_ADICIONAL,
        payload: {
            idSolicitud
        }
    }
}